module.exports = __webpack_public_path__ + "static/media/regular_paper_straw_black3.d0e9253b.png";